import { render, staticRenderFns } from "./OpenbankPolicy.vue?vue&type=template&id=747efd8a&"
import script from "./OpenbankPolicy.vue?vue&type=script&lang=js&"
export * from "./OpenbankPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports